export enum DrawerBlog {
    Edit = 'Edit Blog',
    Create = 'Create Blog',
}
export interface Iblog {
    id: number;
    title: string;
    heading: string;
    content:string;
    date: string;
    description: string;
    img:string|null;
    createdAt: string;
    updatedAt: string;
    deletedAt: null | string;
}
export interface IblogDto {
    title: string;
    heading: string;
    date: string;
    description: string;
    content:string;
    img:string|null|File;
}
